import { render, staticRenderFns } from "./EditBook.vue?vue&type=template&id=64e6cf57&scoped=true"
import script from "./EditBook.vue?vue&type=script&lang=js"
export * from "./EditBook.vue?vue&type=script&lang=js"
import style0 from "./EditBook.vue?vue&type=style&index=0&id=64e6cf57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e6cf57",
  null
  
)

export default component.exports